import { Component, OnInit} from '@angular/core';
import { PathLocationStrategy, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    PathLocationStrategy,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ]
})
export class AppComponent implements OnInit {
    title = 'portalCliente';
    menuActive: boolean;
    activeMenuId: string;

    constructor(private ngxService: NgxUiLoaderService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                pathLocationStrategy: PathLocationStrategy) {
        const basePath = pathLocationStrategy.getBaseHref();
        const absolutePathWithParams = pathLocationStrategy.path();

        if (basePath !== absolutePathWithParams) {
            router.navigateByUrl(absolutePathWithParams);
        }
    }

    ngOnInit() {
        const path = this.activatedRoute.snapshot.queryParams['idEmpresa'];
        const navigateTo = '/' + path;
        if (path) {
            this.router.navigate([navigateTo]);
        }

        this.ngxService.start();
        setTimeout(() => {
            this.ngxService.stop(); // stop foreground loading
        }, 100);

        this.ngxService.startBackground('do-background-things');
        this.ngxService.stopBackground('do-background-things');
    }

    onMenuButtonClick(event: Event) {
        this.menuActive = !this.menuActive;
        event.preventDefault();
    }
}
